import { render } from "./RevolutionScreen.vue?vue&type=template&id=626d1c38&scoped=true"
import script from "./RevolutionScreen.vue?vue&type=script&lang=js"
export * from "./RevolutionScreen.vue?vue&type=script&lang=js"

import "./RevolutionScreen.vue?vue&type=style&index=0&id=626d1c38&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626d1c38"]])

export default __exports__